import type { FaireProductEntity } from "../../entity_types/product";

export const p_eru77z2x9c: FaireProductEntity = {
  token: "p_eru77z2x9c",
  type: "product",
  name: "Bright Pink Sequin Wing Beaded Statement Earrings",
  brandToken: "b_vjqfbthsp3",
  brandName: "Brookhaven Baubles",
  imageUrl: "https://cdn.faire.com/fastly/060aa7d8cd8474be964f8bd1b1dcfbe3aeae23335548d8bfa9427ffe2b7a2444.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4de8c8fd1fcf51c49329ee4b9ff4c9d23b2902128e01335b50c492f28fd9a976.jpeg",
    "https://cdn.faire.com/fastly/a2cc0a57eba3b84443149a2387d40538532620f3d669a75f1059e0dc8dadc193.jpeg"
  ],
  priceDollars: 14,
  description: "Bright Pink Sequin Wing Beaded Earrings - Brookhaven Baubles - Southern Statement Jewelry - Beaded Statement Earrings\n\nBright Pink Wing Beaded Earrings - Southern Statement Jewelry - Beaded Statement Earrings - Fashion Earrings for Her \n\nThese lightweight earrings are made from acrylic seed beads that you will practically forget you are wearing them.\n\nOur earrings are the perfect statement for any occasion or outfit! Perfect for every occasion, from casual days to special events like weddings and birthdays. Get a pair for yourself, your bestie, or as a gift!\n\nAll posts are lead and nickel-free and very lightweight for easy everyday wear.\n\nAll images are copyrighted by Brookhaven Baubles. All rights reserved.",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T16:32:08.241Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
